"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PageController = /*#__PURE__*/function () {
  function PageController() {
    _classCallCheck(this, PageController);
    this.body = document.getElementsByTagName("body")[0];
    this.header = document.getElementsByTagName("header")[0];
    this.footer = document.getElementsByTagName("footer")[0];
    this.content = document.getElementsByTagName("main")[0];
    this.template = $('body').data('template');
    this.percentage100ValidateInputEl = ".percentage-100-validation";
    this.flashMessage = new FlashMessage();
    this.arrayUtils = new ArrayUtils();
    this.dateUtils = new DateUtils();
    this.numberUtils = new NumberUtils();
    this.stringUtils = new StringUtils();
    this.footerLayout = new FooterComponent(this.header, this.footer, this.content);
    this.validatePercentage100Number();
  }
  return _createClass(PageController, [{
    key: "validatePercentage100Number",
    value: function validatePercentage100Number() {
      var _this = this;
      $(document).on("change", _this.percentage100ValidateInputEl, function () {
        var input = $(this);
        var percentage = parseFloat(input.val());
        if (percentage > 100) {
          input.val(100);
          input.change();
        }
        if (percentage < 0) {
          input.val(0);
          input.change();
        }
      });
    }
  }]);
}();
function deleteRecord(el) {
  var link = $(el).attr("data-link");
  var messageRaw = $(el).attr("data-message");
  if (confirm(messageRaw)) {
    $.nette.ajax({
      url: link,
      type: 'GET'
    });
  }
}